<template>
  <b-modal
    ref="modal"
    hide-footer
    size="md"
    title="Save Your API Key"
    @hidden="onModalHidden"
  >
    <div class="api-key-security">
      <b-alert show variant="warning" class="d-flex align-items-center">
        <md-icon icon="warning" class="mr-2" />
        <strong>This is the only time you will see this key!</strong>
      </b-alert>

      <p class="mb-3">
        Please copy and save it securely. You won't be able to see it again.
      </p>

      <div class="key-display mb-3">
        <b-form-group label="API Key:">
          <b-input-group>
            <b-form-input
              :value="apiKey"
              readonly
              size="sm"
              class="font-monospace"
            />
            <template #append>
              <b-button
                variant="outline-primary"
                size="sm"
                @click="copyToClipboard"
              >
                <md-icon :icon="copyIcon" />
                {{ copyText }}
              </b-button>
            </template>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="warning-list">
        <h6>Security Best Practices:</h6>
        <ul class="text-muted small">
          <li class="text-success">
            <md-icon icon="check_circle" class="text-success" />
            Store it in a password manager
          </li>
          <li class="text-success">
            <md-icon icon="check_circle" class="text-success" />
            Keep it in a secure environment variable
          </li>
          <li class="text-danger">
            <md-icon icon="cancel" class="text-danger" />
            Never commit it to version control
          </li>
          <li class="text-danger">
            <md-icon icon="cancel" class="text-danger" />
            Don't share it publicly
          </li>
        </ul>
      </div>

      <div class="text-right mt-4">
        <b-button
          variant="primary"
          @click="confirmAndClose"
          :disabled="!confirmed"
        >
          <md-icon icon="check" />
          I Have Saved The Key
        </b-button>
      </div>

      <div class="text-center mt-3">
        <small class="text-muted">
          This modal will auto-close in {{ countdown }} seconds
        </small>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'KeySecurityModal',
  data() {
    return {
      apiKey: '',
      copyIcon: 'content_copy',
      copyText: 'Copy',
      confirmed: false,
      countdown: 120,
      countdownInterval: null
    };
  },
  methods: {
    show(key) {
      this.apiKey = key;
      this.confirmed = false;
      this.copyIcon = 'content_copy';
      this.copyText = 'Copy';
      this.countdown = 120;
      this.$refs.modal.show();
      this.startCountdown();
    },
    hide() {
      this.$refs.modal.hide();
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.apiKey)
        .then(() => {
          this.copyIcon = 'check';
          this.copyText = 'Copied!';
          this.confirmed = true;
          setTimeout(() => {
            this.copyIcon = 'content_copy';
            this.copyText = 'Copy';
          }, 2000);
        })
        .catch(() => {
          this.$root.showAlert('Failed to copy to clipboard', { variant: 'danger' });
        });
    },
    confirmAndClose() {
      if (this.confirmed) {
        this.hide();
      }
    },
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.hide();
        }
      }, 1000);
    },
    onModalHidden() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      this.$emit('hidden');
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
};
</script>

<style scoped>
.api-key-security {
  padding: 1rem 0;
}

.key-display {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;
  border: 2px dashed #dee2e6;
}

.font-monospace {
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.875rem;
}

.warning-list ul {
  list-style: none;
  padding-left: 0;
}

.warning-list li {
  padding: 0.25rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
